















































































































import { Component, Ref, Mixins, Watch } from 'vue-property-decorator'
import loginCore from './login.core'
import { SendMessageParams } from '@packages/authentication'
import { ElForm } from 'element-ui/types/form'
import UserModule from '@api/module/customer/user/UserModule'
import { AccountType } from '@packages/authentication/interfaces/LoginParams'
import LoginDialogModule from '@/portal/store/login/LoginDialogModule'
import CommonModule from '@api/module/common/common/CommonModule'
const passwordRegexp = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z\W]{6,18}$/

@Component
export default class extends Mixins(loginCore) {
  // mixins: [loginCore],

  passwordState = false
  repeatPasswordState = false
  showClass = 'ico-pwd-show'
  hideClass = 'ico-pwd-hide'
  bindingWeixin = false
  isExists = false
  stepCount = 0
  // 实为布尔值，此处赋值帐号值。用来解决记住帐号和密码后，图形验证码无法输入问题
  isPhoneNumberValid = false
  setPasswordForm = {
    password: '',
    repeatPassword: ''
  }
  chackIsExist = false
  setPasswordFormRules = {
    password: [
      {
        message: '请输入6-18位由数字和字母组合的密码',
        required: true,
        pattern: passwordRegexp,
        trigger: 'blur'
      }
    ],
    repeatPassword: [
      {
        required: true,
        trigger: 'blur',
        pattern: passwordRegexp,
        validator: (rules: any, value: any, callback: (error?: Error) => void) => {
          if (value) {
            if (value !== this.setPasswordForm.password) {
              callback(new Error('两次输入的密码不一致！'))
            } else {
              callback()
            }
          } else {
            callback(new Error('请输入6-18位由数字和字母组合的密码'))
          }
        }
      }
    ]
  }

  changeRepeatPasswordState() {
    this.repeatPasswordState = !this.repeatPasswordState
  }
  changePasswordState() {
    this.passwordState = !this.passwordState
  }

  @Ref('elForm') elForm: ElForm
  next() {
    this.elForm.validate(async valid => {
      if (valid) {
        this.chackIsExist = true
        try {
          const { data: isExists } = await UserModule.isPhoneNumberAccountExists(this.formData.account)
          this.isExists = isExists
          if (!this.isExists) {
            this.stepCount++
          } else {
            await this.doBindWeixin(this.formData.account, this.formData.password)
          }
        } catch (e) {
          // todo
        } finally {
          this.chackIsExist = false
        }
      }
    })
  }

  hideBandingDialog() {
    LoginDialogModule.setShowBindingWeixinDialog(false)
  }

  @Ref('setPasswordForm') setPasswordFormValue: ElForm
  async bindWeiXin() {
    this.setPasswordFormValue.validate(async valid => {
      if (!valid) return
      this.bindingWeixin = true
      try {
        console.log(this.formData)

        await this.doBindWeixin(this.formData.account, this.setPasswordForm.password)
      } catch (e) {
        // 不做
      } finally {
        this.bindingWeixin = false
      }
    })
  }
  // 获取短信验证码
  async getPhoneCaptcha() {
    this.applyingCaptcha = true
    const sendMessage = new SendMessageParams()
    sendMessage.phoneNumber = this.formData.account
    sendMessage.accountType = AccountType.customer
    try {
      const result = await this.$authentication.sendMessageNoValidate(sendMessage)
      this.phoneCaptchaTicket = result.data.captchaTicket
      this.getMessageCoding = true
      if (result.status.code === 4001) {
        this.loginResult = result.status
        return
      }
      this.countDown()
    } catch (e) {
      console.log(e)
    } finally {
      this.applyingCaptcha = false
    }
  }

  async created() {
    await CommonModule.init()
    this.phoneCaptchaMustValidate = true
  }

  @Watch('stepCount', { immediate: true, deep: true })
  changeStep(val: number) {
    this.$emit('changeStep', !!val)
  }
}
